export default __webpack_public_path__ + "static/media/Linero.94075100.png";